import type { Tomo } from '../types/content'

export const tomos: Tomo[] = [
  {
    number: 1,
    emoji: '📗',
    tag: 'El Método',
    title: 'El Método de las 2 Horas',
    accent: '#22c55e',
    tagline:
      'El corazón del sistema. Todo lo que necesitás para arrancar desde cero y resolver tu semana en una sola sesión de cocina.',
    bullets: [
      'La Regla del 3x3 que organiza toda tu semana en una decisión',
      'El Domingo de Preparación paso a paso con tiempos exactos',
      'Cómo organizar heladera y freezer para que nada se tire',
      'Recetas base con pollo, carne, huevo, arroz, papa y lentejas',
      '5 aderezos que transforman cualquier plato simple en algo rico',
    ],
  },
  {
    number: 2,
    emoji: '🍂',
    tag: 'Otoño / Invierno',
    title: 'Otoño / Invierno',
    accent: '#d1603d',
    tagline:
      'El sistema adaptado a la temporada fría. Más calor, más sabor, mismo método.',
    bullets: [
      'Zapallo, remolacha y acelga como estrella de la temporada',
      'Guisos express y sopas que se hacen solos',
      'Modo presupuesto mínimo para las semanas más ajustadas',
      'Menú semanal invernal completo con lista de compras estacional',
    ],
  },
  {
    number: 3,
    emoji: '☀️',
    tag: 'Primavera / Verano',
    title: 'Primavera / Verano',
    accent: '#e0a80d',
    tagline: 'Cuando el calor cambia todo, el sistema también se adapta.',
    bullets: [
      'Bowls fríos y wraps que reemplazan los guisos',
      'Aderezos frescos que hacen todo el trabajo',
      'Sistema 100% sin microondas para los días fuera de casa',
      'Menú semanal de verano con conservación para altas temperaturas',
    ],
  },
  {
    number: 4,
    emoji: '🍱',
    tag: 'Viandas',
    title: 'El Especial Viandas',
    accent: '#16a34a',
    tagline: 'Para los que trabajan y quieren comer bien lejos de casa.',
    bullets: [
      '20 viandas distintas listas en 3 minutos',
      'Opciones sin cadena de frío y sin microondas',
      'Armado del tupper la noche anterior en menos de 5 minutos',
      'Planificador semanal y checklist nocturno incluidos',
    ],
  },
  {
    number: 5,
    emoji: '🥑',
    tag: 'Desayunos',
    title: 'Desayunos y Snacks',
    accent: '#4ade80',
    tagline: 'Porque la alimentación no empieza al mediodía.',
    bullets: [
      'Desayunos en batch para tener listos toda la semana',
      'Muffins, barras de avena y granola sin azúcar',
      'Licuados proteicos sin suplementos caros',
      'Opciones express de 2 minutos para los días que arrancás corriendo',
    ],
  },
  {
    number: 6,
    emoji: '🎉',
    tag: 'Fiestas',
    title: 'Fiestas y Reuniones',
    accent: '#a855f7',
    tagline: 'Para que el sistema no se rompa cuando hay vida social.',
    bullets: [
      'Filosofía 80/20 para disfrutar sin culpa ni ansiedad',
      'Empanadas al horno, pizza integral y picadas saludables',
      'Versiones livianas de los clásicos argentinos que todos amamos',
      'Postres sin azúcar refinada que nadie nota que son saludables',
    ],
  },
]

export const tomoIncludes: string[] = [
  '100% listo — abrís el PDF y arrancás',
  'Lista de compras semanal incluida',
  'Checklist imprimible de cada sistema',
  'Tabla de conservación y tiempos exactos',
  'Ingredientes de súper, feria o verdulería de barrio',
  'Diseñado 100% para el argentino — sin ingredientes raros',
]
